(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["privacy-banner"]) return;
  try {
    
  class PrivacyBanner extends HTMLElement {
    constructor() {
      super();
      this.acceptButton = this.querySelector('[data-privacy-accept]');
      this.declineButton = this.querySelector('[data-privacy-decline]');
      this.loadAttempts = 0;
    }

    connectedCallback() {
      this.acceptButton?.addEventListener('click', () => this.setConsent(true));
      this.declineButton?.addEventListener('click', () => this.setConsent(false));

      this.loadPrivacyApi();
    }

    // The Customer Privacy API isn't just present on window.Shopify — it
    // must be explicitly initialized with loadFeatures() first. Without
    // this, setTrackingConsent()'s writes don't reliably persist, which is
    // why the banner can keep reappearing after being "accepted": every
    // page load was calling shouldShowBanner()/setTrackingConsent() against
    // an API that was never actually finished loading.
    loadPrivacyApi() {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        if (this.loadAttempts++ > 20) return;
        setTimeout(() => this.loadPrivacyApi(), 300);
        return;
      }

      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) {
          console.error('[privacy-banner] Failed to load Shopify Customer Privacy API', error);
          return;
        }

        this.privacyApiReady = true;

        // shouldShowBanner() has been observed on this store to keep
        // returning true even once currentVisitorConsent() shows every
        // category already recorded (e.g. all "yes") — a Shopify-side
        // inconsistency between the two, confirmed via the console rather
        // than assumed, not something fixable from theme code. Treating
        // "has the visitor already answered" as authoritative instead of
        // shouldShowBanner() works around it, since setConsent() below
        // always writes all four categories together, in one call. A
        // visitor who's never interacted has every category set to ""
        // (confirmed via the console, not assumed — this isn't the
        // "no_interaction" string the API docs might suggest).
        const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        const alreadyAnswered = consent && Object.values(consent).some((value) => value !== '');

        if (!alreadyAnswered && window.Shopify.customerPrivacy.shouldShowBanner()) {
          this.hidden = false;
        }
      });
    }

    setConsent(granted) {
      if (!this.privacyApiReady) {
        // Was previously a silent no-op — if this fires, the click did
        // nothing and the API never became ready on this page load (e.g.
        // loadFeatures() failed or is still retrying), which looks
        // identical to "accepting didn't work" from the outside but has a
        // different fix than a persistence problem.
        console.warn('[privacy-banner] setConsent called before the Customer Privacy API was ready; ignoring click.');
        return;
      }

      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: granted,
          marketing: granted,
          preferences: granted,
          sale_of_data: granted,
        },
        () => {
          this.hidden = true;
        }
      );
    }
  }

  customElements.define('privacy-banner', PrivacyBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.waitlist-form__form');
    if (!form) return;

    var section = form.closest('.waitlist-form');
    var listId = section && section.dataset.klaviyoListId;
    if (!listId) return;

    var emailInput = form.querySelector('input[name="contact[email]"]');
    var email = emailInput && emailInput.value;
    if (!email) return;

    var firstNameInput = form.querySelector('input[name="contact[first_name]"]');
    var lastNameInput = form.querySelector('input[name="contact[last_name]"]');

    // Fired with keepalive so the request survives the native form
    // submission navigating away from the page right after this. Signing
    // up here is itself the marketing consent (see the note setting), so
    // unlike the contact form panel this doesn't need a separate checkbox.
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=WUbcwU', {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Waitlist signup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: (firstNameInput && firstNameInput.value) || undefined,
                  last_name: (lastNameInput && lastNameInput.value) || undefined,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      })
    });
  });

  } catch(e) { console.error(e); }
})();
})();
